export class MethodEvaluationErrorResponse {
  srcDiscussion: any;
  destDiscussion: any;
  method: any;
}
